const divisionLabels = ['6-10', '11-12', '13-14', '15-16', '17-18', '19-24', '25-29', '30-34', '35-39', '40+'];

export const divisionColorKeys = {
    '6-10': 'primary',
    '11-12': 'primary',
    '13-14': 'primary',
    '15-16': 'primary',
    '17-18': 'primary',
    '19-24': 'tertiary',
    '25-29': 'tertiary',
    '30-34': 'tertiary',
    '35-39': 'tertiary',
    '40+': 'primary',
    'Top': 'secondary',
};

export const genderLabels = {
    m: 'Male',
    f: 'Female',
};

export const topLabels = {
    m: 'Mens',
    f: 'Womens',
};

export const divisionColors = ['primary', 'primary', 'primary', 'primary', 'primary', 'tertiary', 'tertiary', 'tertiary', 'tertiary', 'tertiary', 'secondary'];


export default divisionLabels;